


















import '@fullcalendar/core/vdom'
import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import FullCalendar from '@fullcalendar/vue'
import rrulePlugin from '@fullcalendar/rrule'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import RemoveEventModal from './RemoveEventModal'

settings =
  name: 'Calendar'
  components: { FullCalendar, RemoveEventModal }

  vue:
    props: ['events', 'seasons', 'options', 'actions']
    mixins: [CalendarService.mixin()]

    data: ->
      actionsModal:
        show: false
        event: null
        dates: null
        position:
          x: 0
          y: 0

      removeModal:
        show: false
        event: null

    mounted: ->
      document.body.addEventListener('click', @hiClickOutside)

    beforeDestroy: ->
      document.body.removeEventListener('click', @hiClickOutside)

    computed:
      calendarKey: -> JSON.stringify({ @events, @seasons })

      calendarOptions: ->
        {
          plugins: [rrulePlugin, interactionPlugin, dayGridPlugin],
          initialView: 'dayGridMonth',
          initialDate: @options?.initialDate,
          events: @events,
          validRange: @validRange,
          fixedWeekCount: false,
          eventOverlap: false,
          aspectRatio: @options?.aspectRatio || 1.75,
          headerToolbar: @options?.headerToolbar

          selectable: if @options?.selectable? then @options.selectable else true
          select: @hiSelect,

          editable: true,
          eventResize: @hiEventResize,
          eventClick: @options?.eventClick || @hiEventClick,
          eventDrop: @hiEventDrop,

          dayCellClassNames: @dayCellClassNames,
          eventContent: @options?.eventContent,
        }

      validRange: -> @options?.validRange || { start: new Date() }

      datesWithError: -> @options?.datesWithError || []

      normalizedSeasons: ->
        nSeasons = []
        return nSeasons unless @seasons
        for season in @seasons
          unless season.starts_at
            nSeasons.push season
            continue

          newSeason = {}
          newSeason.start_day = parseInt dayjs(season.starts_at).format('DD')
          newSeason.start_month = parseInt dayjs(season.starts_at).format('MM')
          newSeason.end_day = parseInt dayjs(season.ends_at).format('DD')
          newSeason.end_month = parseInt dayjs(season.ends_at).format('MM')
          nSeasons.push newSeason
        nSeasons

      actionsForRemoveEventModal: ->
        removeInstance: @removeInstanceEvent
        removeInstanceAndFollowing: @removeInstanceAndFollowingEvents
        remove: @removeEvent

    methods:
      hiSelect: (event) ->
        { target } = event.jsEvent
        return if target.closest('.fc-day-disabled, .disabled, .out-of-season')

        end = dayjs(event.endStr).subtract(1, 'days').format(CalendarService.DATE_FORMAT)
        @actions?.select?(event.startStr, end)

      hiEventClick: (info) ->
        info.jsEvent.stopPropagation()
        event = @findEvent info.event.id
        @actionsModal =
          show: true
          event: event
          date: info.event.startStr
          position:
            x: info.jsEvent.pageX
            y: info.jsEvent.pageY

      hiEventResize: (info) ->
        if @normalizedSeasons.length
          startIsInSeason = CalendarService.isInSeason @normalizedSeasons, info.event.startStr
          endIsInSeason = CalendarService.isInSeason @normalizedSeasons, info.event.endStr
          if !startIsInSeason || !endIsInSeason
            info.revert()
            return

        event = @findEvent info.event.id

        fromDates = { start: info.oldEvent.startStr }
        toDates = { start: info.event.startStr, end: info.event.endStr }

        if event.rrule?
          @resizeRRuleEvent event, fromDates, toDates
        else
          @resizeSingleEvent event, toDates

        @actions?.eventResize?(info.event)

      hiEventDrop: (info) ->
        if @normalizedSeasons.length
          startIsInSeason = CalendarService.isInSeason @normalizedSeasons, info.event.startStr
          endIsInSeason = CalendarService.isInSeason @normalizedSeasons, info.event.endStr
          if !startIsInSeason || !endIsInSeason
            info.revert()
            return

        event = @findEvent info.oldEvent.id

        fromDates = { start: info.oldEvent.startStr }
        toDates = { start: info.event.startStr, end: info.event.endStr }

        if event.rrule?
          @moveRRuleInstance event, fromDates, toDates
        else
          @moveSingleInstance event, toDates

        @actions?.eventDrop?(info)

      hiPromptToEdit: ->
        @actions?.promptToEdit?(@actionsModal.event)

      hiPromptToRemove: ->
        @removeModal =
          show: true
          event: @actionsModal.event
          date: @actionsModal.date

      hiClickOutside: ->
        @actionsModal =
          show: false
          event: null
          dates: null
          position:
            x: 0
            y: 0

      dayCellClassNames: (...args) ->
        [{ date }] = args
        day = dayjs date
        classes = @options?.dayCellClassNames?(...args) || []

        hasError = @datesWithError.some((d) => day.isSame(d, 'day'))
        classes.push 'error' if hasError

        if @normalizedSeasons?.length
          unless CalendarService.isInSeason(@normalizedSeasons, date)
            classes.push 'out-of-season'
            classes.push 'fc-day-disabled'

        classes

export default VueOptions.vue settings
